import React, { useRef } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { User360InviteConfirm, User360InviteConfirmVariables } from './__generated__/User360InviteConfirm';

import { LayoutDefault, Loading } from '../../shared/ui';
import { useQueryParams } from '../../shared/router';
import { auth } from '../../shared/auth';
import { useResetCurrentUserAndHistoryPush } from '../../shared/user';

const PATH_INVITE_CONFIRM_LANDING = '/sign-up/password';

const USER_360_INVITE_CONFIRM = gql`
  mutation User360InviteConfirm($input: UserInviteConfirmInput!) {
    user360InviteConfirm(input: $input) {
      token
    }
  }
`;

function Invite() {
  const queryParams = useQueryParams();
  const code = queryParams.get('code');
  if (!code) {
    throw new Error('Code is not found in query params');
  }
  const resetCurrentUserAndHistoryPush = useResetCurrentUserAndHistoryPush();
  const [user360InviteConfirm] = useMutation<User360InviteConfirm, User360InviteConfirmVariables>(
    USER_360_INVITE_CONFIRM
  );
  const ref = useRef<boolean>();

  // Run only on first render
  if (!ref.current) {
    ref.current = true;

    const input = { code };
    user360InviteConfirm({ variables: { input: input } }).then((result) => {
      return auth.authenticate(result.data!.user360InviteConfirm!.token).then(() => {
        resetCurrentUserAndHistoryPush(PATH_INVITE_CONFIRM_LANDING);
      });
    });
  }

  return (
    <LayoutDefault>
      <h2>Invite</h2>
      <Loading />
    </LayoutDefault>
  );
}

export { Invite };
